export const grantTypes = [
  { label: 'Implicit', value: 'implicit' },
  { label: 'Code', value: 'code' },
  { label: 'Password', value: 'password' },
  { label: 'Refresh token', value: 'refresh_token' },
  { label: 'Client credentials', value: 'client_credentials' },
];

export default grantTypes;
